var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader-wrapper active",class:_vm.sizeClass},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-layer spinner-teal-only"},[_c('div',{staticClass:"circle-clipper left"},[_c('div',{staticClass:"circle"})]),_c('div',{staticClass:"gap-patch"},[_c('div',{staticClass:"circle"})]),_c('div',{staticClass:"circle-clipper right"},[_c('div',{staticClass:"circle"})])])
}]

export { render, staticRenderFns }